import { i18n } from '@/utils/i18n';

export const columns = {
    id: {
        show: true,
        title: "№",
        sortable: true,
        column: 'id'
    },
    citizenship: {
        show: true,
        title: i18n.t('message.citizenship'),
        sortable: true,
        column: 'citizenship'
    },
    code: {
        show: true,
        title: i18n.t('message.code_id'),
        sortable: true,
        column: 'code'
    },
    state_id: {
        show: true,
        title: i18n.t('message.country'),
        sortable: true,
        column: 'state_id'
    },
    created_at: {
        show: true,
        title: i18n.t('message.date'),
        sortable: true,
        column: 'created_at'
    },
    updated_at: {
        show: false,
        title: i18n.t('message.update_date'),
        sortable: true,
        column: 'updated_at'
    },
    settings: {
        show: true,
        title: i18n.t('message.settings'),
        sortable: false,
        column: 'settings'
    }
};
